import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { createI18n } from '@noxverify/i18n';
import { App } from './App';
import { eagerEnResources, attachLazyLocaleLoader } from './i18n-resources';

// Self-hosted fonts (IBM Plex Sans + Mono). Replaces the prior Google Fonts
// stylesheet link; the old serif display face is dropped entirely per the
// Precision Blue theme.
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './styles.css';

// ---------------------------------------------------------------------------
// i18n bootstrap
//
// Portal is an authenticated, no-index SPA. We previously inlined all 22
// locales × 2 namespaces (common, portal) into the main JS chunk, which
// dominated the bundle (Lighthouse perf finding). Now English (the fallback +
// default) is bundled eagerly and every non-English locale is code-split into
// its own chunk, loaded on demand by `attachLazyLocaleLoader`.
//
// Trade-off: switching to a non-en locale fetches a small JSON chunk first;
// `useSuspense:false` renders the English fallback until it resolves (a
// sub-second flash on first paint for non-en). Acceptable for this no-index UX.
// ---------------------------------------------------------------------------
const i18n = createI18n({
  resources: eagerEnResources,
  useHttpBackend: false,
  ns: ['common', 'portal'],
  defaultNS: 'portal',
});

// Lazy-load the active locale (and any future language switch) on demand.
attachLazyLocaleLoader(i18n);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </React.StrictMode>,
);
